import { Component } from '@angular/core';

@Component({
  selector: 'app-plans-icon',
  imports: [],
  templateUrl: './plans-icon.html',
  styleUrl: './plans-icon.css'
})
export class PlansIcon {

}
